








import {Component, Vue, Watch} from 'vue-property-decorator';
import ImageManager from '@/script/ImageManager';
import {Getter} from 'vuex-class';
import GimmickManager from '@/script/GimmickManager';

@Component({
  components: {},
})
export default class App extends Vue {
  @Getter('status') private status!: number;
  @Getter('hookTime') private hookTime!: Date;
  private bgImage: string = ImageManager.INSTANCE.get('背景')!;

  @Watch('hookTime')
  private onChangeStatus() {
    const gimmickAction = GimmickManager.INSTANCE.gimmickInfo!.actionList.filter(
      (action) => action!.status === this.status,
    )[0];
    if (!gimmickAction) { return; }

    gimmickAction.eventList.forEach((event) => {
      if (event.type === 'page') {
        this.$router.push({ name: event.urlTarget }).then();
      }
    });
  }
}
